import { useContext } from 'react';
import { dialogContextObj } from '../context';

/**
 * Хук для доступа к контексту диалога - функции confirm
 * */
export var useDialogConfirm = function useDialogConfirm() {
  return useContext(dialogContextObj);
};